var map = {
	"./amazon.png": 622,
	"./american-express.png": 623,
	"./cirrus.png": 624,
	"./dinners-club.png": 625,
	"./direct-debit.png": 626,
	"./discover.png": 627,
	"./ebay.png": 628,
	"./jcb.png": 629,
	"./maestro.png": 630,
	"./mastercard.png": 631,
	"./paypal.png": 632,
	"./solo.png": 633,
	"./switch.png": 634,
	"./visa-electron.png": 635,
	"./visa.png": 636
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1303;